export { default as CameraPermissionDenied } from "./CameraPermissionDenied";
